module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-04@2x.39ad8e53.jpg";